<template>
  <div class="content-class">
    <v-container fluid>
      <v-row class="row-class" justify="space-between" align="center">
        <v-col v-for="(item,index) in countDownList" :key="index" cols="6">
          <v-card max-height="250" class="pa-3">
            <v-card-title>
              <span class="text-h6">距离{{ item.name }}</span>
            </v-card-title>
            <v-card-text>
            <span class="text-h4 font-weight-black">
                {{ interval(item) }}
            </span>
              天
              <div class="mt-2">
              <span class="text-h6">
                {{ item.date }}
              </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {openData} from "@/api/jsonp/calendar";

export default {
  name: "countDown",
  data: () => ({
    holiday: [],
    today: undefined,
    countDownList: []
  }),
  mounted() {
    this.initDate()

    window.callBackOpAladdin = (data) => {
      let _holidayList = data.data[0].holiday
      this.holiday = Object.keys(_holidayList).map(key => _holidayList[key])
      this.parseDate()
    }
  },
  methods: {
    initDate() {
      this.today = this.$moment();

      this.getCalendarMap();
    },
    parseDate() {
      let _yearIndex = this.holiday.findIndex(item => parseInt(item.year, "YYYY-MM-DD") === this.today.year())

      let _holidayList = [...this.holiday[_yearIndex].list, ...this.holiday[_yearIndex + 1].list]

      let _list = _holidayList.filter(item => this.today.isBefore(this.$moment(item.date)))

      this.countDownList = _list.slice(0, 2)
    },
    interval({date}) {
      return this.$moment(date).diff(this.today, 'days') + 1
    },
    getCalendarMap() {
      let msCalendarMap = {
        'tn': 'wisetpl',
        'format': 'json',
        resource_id: 39042,
        query: '法定节假日',
        t: new Date().getTime(),
        output: 'jsonp',
        cb: 'callBackOpAladdin',
      }
      openData(msCalendarMap).then()
    },
  }
}
</script>

<style scoped>
.content-class {
  height: 250px;
  max-width: 400px;
  margin: 0 auto;
}

.row-class {
  height: 100%;
}
</style>
